import _ from '@/utils/lodash-optimized'
import React from 'react'

import * as Mapper from '../../../../../lib/Proxy/patient'
import {
  bindTargetMixin,
  makeAutobindedInput, SaveButton,
  SelectInput,
  TextInput
} from '../../../../shared/FormBuilder'
import { Button } from '../../../../shared/NarusMaterial'

import { updatePatientPar } from './actions'

const PARbase = ({ value, onChange, modal }) => (
  <div
    className='form-section'
    style={modal
      ? {
        marginTop: '0px',
        padding: '0px'
      }
      : {}}
  >
    <div>
      {modal ? <h2 style={{ marginBottom: '10px' }}> PAR </h2> : <h1> PAR </h1>}
      <div className='col-12-xs'>
        {_.range(1, 6).map((val, index) => (
          <Button
            key={`par-button-${index}`}
            style={{ marginLeft: 0 }}
            long
            label={val.toString()}
            grey={val !== value}
            teal={val === value}
            onClick={() => onChange(val)}
          />
        ))}
      </div>
    </div>
  </div>
)

const PAR = makeAutobindedInput(PARbase)

class HealthProgram extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { patient } = this.props
    patient.par = this.state.value.par
    patient.healthProgram = this.state.value.healthProgram
    patient.primaryConcern = this.state.value.primaryConcern
    const patientToSave = Mapper.mapFormToPatient(patient)
    this.props.dispatch(updatePatientPar(patient.id, patientToSave))
  }

  render () {
    const makeDisplay = arr => arr.map(v => ({
      ...v,
      label: v.value
    }))
    const HEALTH_PROGRAMS = [
      {
        value: 'Cancer',
        level: 1
      },
      {
        value: 'Cardio',
        level: 1
      },
      {
        value: 'Infectious Disease',
        level: 1
      },
      {
        value: 'Liver',
        level: 1
      },
      {
        value: 'Neuro',
        level: 1
      },
      {
        value: 'Pulmonary',
        level: 1
      },
      {
        value: 'Renal',
        level: 1
      },
      {
        value: 'Behavioral Health',
        level: 1
      },
      {
        value: 'Diabetes',
        level: 1
      },
      {
        value: 'Endocrine',
        level: 1
      },
      {
        value: 'Maternity',
        level: 1
      },
      {
        value: 'Other',
        level: 2
      }
    ]
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
        <PAR
          name='par'
          modal
          patientStatus={this.props.patientStatus}
          expired={this.props.expired}
        />
        <div>
          <h2 style={{ marginBottom: '10px' }}>Lucent Health Program</h2>
          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                label='Lucent Health Program'
                name='healthProgram'
                options={makeDisplay(HEALTH_PROGRAMS)}
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Primary Concern'
                name='primaryConcern'
              />
            </div>
          </div>

        </div>
        <div
          className='row'
          style={{ textAlign: 'right' }}
        >
          <div className='col-xs-12'>
            <SaveButton
              formKey={this.props.formKey}
              label='Save'
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>

    )
  }
}

export { PAR, HealthProgram }
